import {create} from "zustand";

interface CohortTypeState {
  cohortValue: number;
  disabledCohort: boolean;
  cohortString: string;
  setCohortValue: (value: number) => void;
  setDisabledCohort: (value: boolean) => void;
  setCohortString: (value: string) => void;
  cohortList: string[];
  cohortCompValue: number[];
  setCohortCompValue: (value: number[]) => void;
}

const useCohortType = create<CohortTypeState>((set) => ({
  cohortValue: 0,
  disabledCohort: false,
  cohortString: "HCM",
  setCohortValue: (value: number) => set(() => ({cohortValue: value})),
  setDisabledCohort: (value: boolean) => set(() => ({disabledCohort: value})),
  setCohortString: (value: string) => set(() => ({cohortString: value})),
  cohortList: ["HCM", "oHCM", "nHCM", "Symptomatic HCM", "Asymptomatic HCM"],
  cohortCompValue: [0, 1],
  setCohortCompValue: (value: number[]) =>
    set(() => ({cohortCompValue: value})),
}));

export default useCohortType;
